import React from 'react';

import * as Styled from './onboarding-side-image.style';

export type OnboardingSideImageProps = {
  imageUrl: string;
  maxImageWidth: number;
  relativeImage?: boolean;
};

export const OnboardingSideImage: React.FC<OnboardingSideImageProps> = ({
  imageUrl,
  maxImageWidth,
  relativeImage,
}) => (
  <Styled.RightPanel>
    <Styled.RightPanelImage
      src={imageUrl}
      $maxWidth={maxImageWidth}
      $relative={!!relativeImage}
      alt="App preview"
    />
  </Styled.RightPanel>
);
